import React from 'react'
import { HubTable } from 'components/HubDefaultTable'
import {
    TableScrollWrapper,
    ConnectionCardList,
    ConnectionCard,
    CardHeader,
    CardBadge,
    CardRow,
    CardLabel,
    CardValue
} from './index.style'

export interface ConnectionItem {
    responsible: string
    interestArea: string
    metWeb: string
    startDate: string
    lastUpdate: string
}

export interface HubStartupConnectionsTableProps {
    items: ConnectionItem[]
}

const MONTHS_PT_SHORT = ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez']

const formatDate = (dateString: string): string => {
    const date = new Date(dateString)
    if (isNaN(date.getTime())) return ''
    const day = String(date.getDate()).padStart(2, '0')
    const month = MONTHS_PT_SHORT[date.getMonth()]
    const year = date.getFullYear()
    return `${day} ${month} ${String(year)}`
}

export const HubStartupConnectionsTable = ({ items }: HubStartupConnectionsTableProps): JSX.Element => {
    const header = [
        'Responsável pela conexão',
        'Área de interesse',
        'Como conheceu',
        'Data de início',
        'Última atualização'
    ]

    const rows = items.map((item) => [
        item.responsible,
        item.interestArea,
        item.metWeb,
        formatDate(item.startDate),
        formatDate(item.lastUpdate)
    ])

    return (
        <>
            <TableScrollWrapper>
                <HubTable header={header} rows={rows} />
            </TableScrollWrapper>
            <ConnectionCardList>
                {items.map((item, index) => (
                    <ConnectionCard key={index}>
                        <CardHeader>
                            <CardBadge>{item.metWeb}</CardBadge>
                        </CardHeader>
                        {item.responsible && (
                            <CardRow>
                                <CardLabel>Responsável:</CardLabel>
                                <CardValue>{item.responsible}</CardValue>
                            </CardRow>
                        )}
                        <CardRow>
                            <CardLabel>Área de interesse:</CardLabel>
                            <CardValue>{item.interestArea}</CardValue>
                        </CardRow>
                        <CardRow>
                            <CardLabel>Data de início:</CardLabel>
                            <CardValue>{formatDate(item.startDate)}</CardValue>
                        </CardRow>
                        <CardRow>
                            <CardLabel>Última atualização:</CardLabel>
                            <CardValue>{formatDate(item.lastUpdate)}</CardValue>
                        </CardRow>
                    </ConnectionCard>
                ))}
            </ConnectionCardList>
        </>
    )
}